import { render } from "./productSupplierPie.vue?vue&type=template&id=f276d154"
import script from "./productSupplierPie.vue?vue&type=script&lang=js"
export * from "./productSupplierPie.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/purchase/components/productSupplierPie.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f276d154"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f276d154', __exports__)) {
    api.reload('f276d154', __exports__)
  }
  
  module.hot.accept("./productSupplierPie.vue?vue&type=template&id=f276d154", () => {
    api.rerender('f276d154', render)
  })

}


export default __exports__